export default __webpack_public_path__ + "static/media/G0425.Glycaemic_tandem1.1692956460000.da317071.jpg";